import { jsx as _jsx } from "react/jsx-runtime";
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { useSegmentedControl } from './hooks';
import { Container, Control, Text } from './ui';
export const SegmentedControl = ({ controls = [], direction = 'horizontal', onChange, size = 'normal', }) => {
    const { isActive, isFocused, onKeyDown, onPress, setRef } = useSegmentedControl({
        controls,
        direction,
        onChange,
    });
    if (controls.length === 0) {
        return null;
    }
    return (_jsx(Container, { "aria-label": "Segmented control", flexDirection: direction === 'vertical' ? 'column' : 'row', role: "tablist", size: size, children: controls.map((control) => (_jsx(Control, { active: isActive(control), "aria-label": control.label, "aria-selected": isActive(control), disabled: control.disabled, onClick: () => onPress(control), onKeyDown: (event) => {
                onEnterOrSpacePress(() => onPress(control))(event);
                onKeyDown(event, control);
            }, ref: setRef(control.value), role: "tab", size: size, tabIndex: control.disabled ? -1 : isFocused(control) ? 0 : -1, children: _jsx(Text, { children: control.label }) }, control.value))) }));
};
//# sourceMappingURL=SegmentedControl.js.map